<template>
	<div class="data-node">
		<Handle
			id="treeDataNode"
			type="source"
			:position="Position.Left"
			:connectable="false"
			style="opacity: 0"
		/>
		<span>{{ label }}</span>
		<Handle
			id="sourceDataNode"
			type="source"
			:position="Position.Right"
			:connectable="handleConnectable"
			style="background: #ff0072;"
		/>
	</div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import {Handle, HandleConnectableFunc, Position} from '@vue-flow/core';

export default defineComponent({
	name: 'DataNode',
	components: {
		Handle,
	},
	props: {
		label: {
			type: String,
		},
	},
	setup() {
		const handleConnectable: HandleConnectableFunc = (node, connectedEdges) => {
			// only allow connections if the node has less than one connection
			// check if the connection is not a tree connection
			connectedEdges = connectedEdges.filter(connectedEdge => connectedEdge.data.type !== "treeConnection");
			return connectedEdges.length < 1;
		}

		return {
			Position,
			handleConnectable,
		};
	},
});

</script>

<style scoped>

.data-node {
	height: 100%;
	width: 100%;
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
	gap: 10px;
	background: white;
	border-radius: 4px;
	border: 1px solid #ff0072;
}

</style>
